import React from 'react';
import { Text as JssText, TextField, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

const GuideNavigationHeader = (): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();

  return (
    <div>
      {sitecoreContext?.route?.fields?.title && (
        <h1>
          <JssText field={sitecoreContext.route.fields.title as TextField} />
        </h1>
      )}
      {sitecoreContext?.route?.fields?.text && (
        <p>
          <JssText field={sitecoreContext.route.fields.text as TextField} />
        </p>
      )}
    </div>
  );
};

export default GuideNavigationHeader;
